import { ButtonGroup as BaseButtonGroup } from "@netlify/ui";

export type ButtonGroupProps = {
  children: React.ReactNode;
  className?: string | undefined;
};

/**
 * A ButtonGroup groups several buttons together.
 *
 * ![Button group](./screenshots/button_group.png)
 *
 * @see {@link Button}
 * @example
 * ```tsx
 * import { ButtonGroup } from "@netlify/sdk/react/components";
 *
 * <ButtonGroup>
 *   <Button level="primary">Confirm</Button>
 *   <Button level="secondary">Cancel</Button>
 * </ButtonGroup>
 * ```
 */
export const ButtonGroup = (props: ButtonGroupProps) => (
  <BaseButtonGroup {...props} />
);
